/*
 * tp-attribution.js — Kanal-Attribution (Spec 196).
 * UTM-Satz + Klick-IDs aus der Landing-URL -> Cart-Attribute (_tp_first_ / _tp_last_)
 * und properties[_tp_last_...] in die Produktformulare (Express-Pfad).
 * Begruendungen und Datenvertrag: docs/tp-attribution.md + docs/spec-kanal-attribution.md.
 */
(function () {
  'use strict';

  var UTM = ['source', 'medium', 'campaign', 'term', 'content'];
  var CLICK = ['gclid', 'gbraid', 'wbraid'];
  var FIELDS = UTM.concat(CLICK);
  var MAX_LEN = 128;
  var CART_GET = '/cart.js';
  var CART_SET = '/cart/update.js';

  function param(name) {
    var q = location.search;
    if (!q) { return ''; }
    var m = q.match(new RegExp('[?&]' + name + '=([^&]*)'));
    if (!m) { return ''; }
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }

  function clean(v) {
    if (!v) { return ''; }
    return String(v).slice(0, MAX_LEN).trim();
  }

  var vals = {}, i;
  for (i = 0; i < UTM.length; i++) { vals[UTM[i]] = clean(param('utm_' + UTM[i])); }
  for (i = 0; i < CLICK.length; i++) { vals[CLICK[i]] = clean(param(CLICK[i])); }

  var hasClick = !!(vals.gclid || vals.gbraid || vals.wbraid);

  // Klick-ID = bezahlter Klick; vom Feed vorbelegtes product_sync korrigieren (siehe Doku).
  if (hasClick) {
    if (!vals.source) { vals.source = 'google'; }
    if (!vals.medium || vals.medium === 'product_sync') { vals.medium = 'cpc'; }
  }

  var hasVals = !!(vals.source || hasClick);

  function stampFrom(attrs) {
    attrs = attrs || {};
    var now = new Date().toISOString();
    var patch = {}, k;

    if (!attrs._tp_first_source) {
      for (k = 0; k < FIELDS.length; k++) { patch['_tp_first_' + FIELDS[k]] = vals[FIELDS[k]]; }
      patch._tp_first_at = now;
    }

    var lastChanged = false;
    for (k = 0; k < FIELDS.length; k++) {
      if ((attrs['_tp_last_' + FIELDS[k]] || '') !== vals[FIELDS[k]]) { lastChanged = true; break; }
    }
    if (lastChanged) {
      for (k = 0; k < FIELDS.length; k++) { patch['_tp_last_' + FIELDS[k]] = vals[FIELDS[k]]; }
      patch._tp_last_at = now;
    }

    if (!Object.keys(patch).length) { return; }

    fetch(CART_SET, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: patch })
    }).catch(function () {});
  }

  function injectInto(form, eff) {
    var old = form.querySelectorAll('input[data-tp-attr]'), j, k, inp;
    for (j = 0; j < old.length; j++) { old[j].parentNode.removeChild(old[j]); }
    for (k = 0; k < FIELDS.length; k++) {
      if (!eff[FIELDS[k]]) { continue; }
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[_tp_last_' + FIELDS[k] + ']';
      inp.value = eff[FIELDS[k]];
      inp.setAttribute('data-tp-attr', '');
      form.appendChild(inp);
    }
  }

  function injectAll(eff) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]'), i;
    for (i = 0; i < forms.length; i++) { injectInto(forms[i], eff); }
  }

  function observeForms(eff) {
    if (typeof MutationObserver === 'undefined') { return; }
    var t = null;
    new MutationObserver(function () {
      if (t) { clearTimeout(t); }
      t = setTimeout(function () { injectAll(eff); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function effective(attrs) {
    if (hasVals) { return vals; }
    attrs = attrs || {};
    var eff = {}, k, any = false;
    for (k = 0; k < FIELDS.length; k++) {
      eff[FIELDS[k]] = clean(attrs['_tp_last_' + FIELDS[k]]);
      if (eff[FIELDS[k]]) { any = true; }
    }
    return any ? eff : null;
  }

  function run(attrs) {
    if (hasVals) { stampFrom(attrs); }
    var eff = effective(attrs);
    if (!eff) { return; }
    if (document.body) { injectAll(eff); observeForms(eff); }
    else {
      document.addEventListener('DOMContentLoaded', function () { injectAll(eff); observeForms(eff); });
    }
  }

  fetch(CART_GET, { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) { run(c && c.attributes); })
    .catch(function () { run(null); });
})();
